<div class="box-dialog-wrapper">
  <header #dialogHeader class="box-dialog-header">
    <box-dialog-header [title]="title" (closeDialog)="closeDialog()"></box-dialog-header>
  </header>
  <main #dialogBody bodyScroll class="box-dialog-content" (bodyScroll)="onBodyScroll($event)">
    <div class="market-card-dialog-content">
      <div class="market-card-dialog-card-container">
        <market-card [marketCard]="marketCard"></market-card>
      </div>
      <p class="market-card-dialog-text">
        {{
          created
            ? t('your_card_is_ready', { _CARD_NAME: cardName })
            : t('we_found_your_card', { _CARD_NAME: cardName })
        }}
      </p>
      <div class="market-card-dialog-rewards">
        <div class="market-card-dialog-reward">
          <span class="market-card-dialog-reward-icon">
            <mat-icon fontSet="material-icons-round">check</mat-icon>
          </span>
          <span class="market-card-dialog-reward-text">
            {{ 'collect_points_from_your_orders_in_supermarkets' | translate: { _SHOP_NAME: shopName } }}
          </span>
        </div>
        <div class="market-card-dialog-reward">
          <span class="market-card-dialog-reward-icon">
            <mat-icon fontSet="material-icons-round">check</mat-icon>
          </span>
          <span class="market-card-dialog-reward-text">
            {{
              'redeem_your_card_points_and_get_discounts' | translate: { _SHOP_NAME: shopName, _CARD_NAME: cardName }
            }}
          </span>
        </div>
      </div>
    </div>
  </main>
  <footer #dialogFooter class="box-dialog-header market-card-dialog-footer">
    <div class="market-card-dialog-footer-container">
      <button box-button theme="primary" class="market-card-dialog-footer-button" (click)="onContinue()">
        {{ 'next_' | translate }}
      </button>
    </div>
  </footer>
</div>
